import { render, staticRenderFns } from "./oc-drawer-header.vue?vue&type=template&id=2b03591c"
import script from "./oc-drawer-header.vue?vue&type=script&lang=js"
export * from "./oc-drawer-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports